"use strict";

// Connecting vendors (plugins)
import "./_vendor";

// Functions
import { burger, dynamicAdaptive, mobileCheck } from "./functions/";
import { slider, currencySlider } from "./components";

// Components
// import { formValidation } from "./components/";

window.addEventListener("DOMContentLoaded", () => {
  mobileCheck();
  burger();
  dynamicAdaptive();
  slider();
  currencySlider();
});
